import type { CSSProperties } from "react";

import { HERO_BLOB } from "./backdrop/geometry";
import { cx } from "./classnames";
import { HERO } from "./content";
import styles from "./Hero.module.css";

const layout = {
  "--width": HERO.width,
  "--gap": HERO.gap,
  "--pad-inline": HERO.paddingInline,
  "--pad-block": HERO.paddingBlock,
  "--tagline-indent": HERO.taglineIndent,
  // The blob is stored on the frame, and the hero sits at (88, 27) on it.
  "--blob-x": HERO_BLOB.box.x - 88,
  "--blob-y": HERO_BLOB.box.y - 27,
  "--blob-w": HERO_BLOB.box.width,
  "--blob-h": HERO_BLOB.box.height,
} as CSSProperties;

/** The page's title block, sitting on its black blob. */
export function Hero() {
  return (
    <header className={styles.hero} style={layout}>
      <svg
        className={styles.blob}
        viewBox={`${HERO_BLOB.box.x} ${HERO_BLOB.box.y} ${HERO_BLOB.box.width} ${HERO_BLOB.box.height}`}
        aria-hidden="true"
        focusable="false"
      >
        <path d={HERO_BLOB.path} transform={HERO_BLOB.transform} fill="#000" />
      </svg>

      <h1 className={cx("type-heading-1", styles.title)}>{HERO.title}</h1>
      <p className={cx("type-subtitle", styles.tagline)}>{HERO.tagline}</p>
    </header>
  );
}
